module.exports = __webpack_public_path__ + "static/media/Vector.25306296.svg";